export enum FCResourceViewTypes {
    Day = 'resourceTimelineDay',
    Week = 'resourceTimelineWeek',
    Month = 'resourceTimelineMonth',
}
